import './assets/fonts/TTCommons/stylesheet.css';
import HeaderMain from './components/Header/HeaderMain.vue';
export default {
  components: {
    HeaderMain
  }
};